


<div *ngIf="appointment" class="app-base">
  <div class="integrated-left">
    <label class="alert-message" *ngIf="existsCurrentInvoice && !readonly">No se puede modificar la valorización porque existe una cobranza realizada</label>
    <div class="integrated-plan">
      <app-integrated-admission-appointment-plan>
      </app-integrated-admission-appointment-plan>
    </div>
    <div class="integrated-validation">
      <app-integrated-admission-appointment-validation>
      </app-integrated-admission-appointment-validation>
    </div>

    <div class="integrated-observation">
      <app-integrated-admission-appointment-observation></app-integrated-admission-appointment-observation>
    </div>
    <app-integrated-admission-appointment-valorization></app-integrated-admission-appointment-valorization>
    <app-integrated-admission-appointment-documentation>
    </app-integrated-admission-appointment-documentation>


  </div>

  <div class="integrated-right">


    <div class="integrated-scann">
      <app-integrated-admission-appointment-scann></app-integrated-admission-appointment-scann>
    </div>
  </div>
</div>
